<template>
  <v-card>
    <v-card-text>
      <h3>Angle</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'degrees (deg)',
          val: 1
        },
        {
          text: 'full circle',
          val: 0.002777777777778
        },
        {
          text: 'grad',
          val: 1.111111111111
        },
        {
          text: 'radians (rad)',
          val: 0.01745329251994
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// angle.vue?319832f4